// https://github.com/jaredpalmer/formik/issues/1840#issuecomment-610460209
// getIn and setIn are helpers exported from Formik which get and set values in complex objects,
// returns a new object if setIn causes a change
// example field names for brevity
import { getIn, setIn } from "formik"

import { getSiteConfig } from "../../../hooks/use-site-config"
import { ingeteamev } from "./extraRules/ingeteamev"

const extraRulesMap = {
  ingeteamev: ingeteamev,
}

const updateAllDependentValues = (name = "", value, formik) => {
  const { values, initialValues } = formik

  // update values object with the newly changed value
  let updatedValues = setIn(values, name, value)

  if (getIn(values, name) !== getIn(updatedValues, name)) {
    // value changed, recalculate other values if needed

    const resetValues = recalculateValues(updatedValues, initialValues)

    updatedValues = { ...updatedValues, ...resetValues }
  }

  return updatedValues
}

const getValueForCheckbox = (event, values) => {
  const { name, value, checked } = event.target

  const currentValue = getIn(values, name)
  const valueProp = value

  // If the current value was a boolean, return a boolean
  if (typeof currentValue === "boolean") {
    return Boolean(checked)
  } // If the currentValue was not a boolean we want to return an array

  var currentArrayOfValues = []
  var isValueInArray = false
  var index = -1

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == "true" || valueProp == "false") {
      return Boolean(checked)
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue
    index = currentValue.indexOf(valueProp)
    isValueInArray = index >= 0
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values

  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp)
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values

  if (!isValueInArray) {
    return currentArrayOfValues
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array

  return currentArrayOfValues
    .slice(0, index)
    .concat(currentArrayOfValues.slice(index + 1))
}

const recalculateValues = (values, initialValues) => {
  let newValues = { ...values }

  // TODO: Apply rules here

  //Extra rules
  const config = getSiteConfig()
  const site = config?.code
  newValues = extraRulesMap[site](newValues)

  return newValues
}

export { updateAllDependentValues, getValueForCheckbox, recalculateValues }
